import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'

import { /* menus,*/ routes } from '_src/config'

import { parseArr, getRoutes, filterMenu } from '_src/utils/tool'

@withRouter
class RedirectException extends Component {
  getPaths (router, key = 'path') {
    let arr = parseArr(router).map(item=>(item[key]))
    arr.push('/login', '/', '/home')
    return arr
  }

  // 将路由换算
  filterRouter (router, allRouterPath) {
    let menus= parseArr(router).map(item=>{
      return { ...item, key: item.path }
    })
    const userinfo = localStorage.getItem('access_info')
    const { id } = userinfo ? JSON.parse(userinfo) : ''
    if ((''+id) !== '1') {
      allRouterPath = allRouterPath.filter(item=>{
        return item.indexOf('/admin') === -1 
      })      
    }
    return filterMenu(menus, allRouterPath)
  }

  render () {
    let allRouterPath = this.getPaths(getRoutes(routes)).map(item=>{
      const pathName = item.split('?')[0]
      return pathName
    })
    let filterRouterPath = this.getPaths(getRoutes(this.filterRouter(routes, allRouterPath)), 'key')
    let unauthorizedPath = routes.filter(item=>{
      return item.unauthorized
    }).map(item=>{
      return item.path
    })

    // 合并不需要权限路由
    filterRouterPath = [...filterRouterPath, ...unauthorizedPath]
    const { location: {pathname} } = this.props
    let Node = null

    // 暂时去除权限控制
    if (!filterRouterPath.includes(pathname) && allRouterPath.includes(pathname)) {
      Node = <Redirect to="/403" />
    }
    
    // 没有路径重定向
    if (!allRouterPath.includes(pathname)) {
      Node = <Redirect to="/404" />
    }
    
    return (
      <div className="app-content">
        { this.props.children }
        {Node}
      </div>
    )
  }
}


const Authorized = (props) => {
  let isLogin = true
  let Node = null
  // 页面内容显示授权判断
  const userinfo = localStorage.getItem('access_info')
  const { pathname } = props
  // 去到登录页面
  if (!userinfo&&pathname.indexOf('/login') === -1) {
    isLogin = false
    Node = <Redirect to="/login" />
    // this.props.history.push('/login')
    // this.props.history.push('/login?q=' + encodeURIComponent(pathname))
    // commonAction({appShow: true})
  }
  return (
    <div>
      {Node}
      {
        isLogin?<RedirectException />:null
      }
    </div>
  )
}

export default Authorized